import { WhatsAppActionTypes } from './whatsapp.types';

const initialState = {
  instances: [],
  instanceWhatsapp: [],
  qrCodeBase64: null,
  chats: [],
  currentMessages: [],
  loading: false,
  timestamp: null,
  error: null,
  pageInfo: {},
  loadingScreen: {
    percent: 0,
    message: '',
    key: ''
  }
};

const whatsappReducer = (state = initialState, action) => {
  switch (action.type) {
    case WhatsAppActionTypes.GET_QR_BASE64_REQUEST:
    case WhatsAppActionTypes.LIST_INSTANCES_REQUEST:
    case WhatsAppActionTypes.EDIT_INSTANCE_REQUEST:
    case WhatsAppActionTypes.GET_WHATSAPP_CHATS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case WhatsAppActionTypes.GET_QR_BASE64_SUCCESS:
      return {
        ...state,
        qrCodeBase64: action.payload,
        loading: false,
        timestamp: action.timestamp
      };

    case WhatsAppActionTypes.LIST_INSTANCES_SUCCESS:
      return {
        ...state,
        instanceWhatsapp: action.payload,
        loading: false
      };

    case WhatsAppActionTypes.EDIT_INSTANCE_SUCCESS:
      return {
        ...state,
        instances: state.instances.map((instance) => instance.phone === action.payload.phone ? action.payload : instance),
        loading: false
      };

    case WhatsAppActionTypes.GET_WHATSAPP_CHATS_SUCCESS:
      return {
        ...state,
        chats: action.payload,
        loading: false
      };

    case WhatsAppActionTypes.GET_WHATSAPP_CHAT_MESSAGES_SUCCESS:
      return {
        ...state,
        currentMessages: action.payload,
        loading: false
      };

    case WhatsAppActionTypes.APPEND_WHATSAPP_CHAT_MESSAGES:
      const incomingMessages = action.payload;

      const updatedMessages = state.currentMessages.map(existingMsg => {
        const incoming = incomingMessages.find(
          msg => (msg.whatsapp_message_id || msg.id) === (existingMsg.whatsapp_message_id || existingMsg.id)
        );
        // Se encontrar uma mensagem nova com o mesmo ID, faz o merge (mantém o antigo, mas atualiza campos novos)
        return incoming ? { ...existingMsg, ...incoming } : existingMsg;
      });

      // Adiciona mensagens que ainda não existem
      const existingIds = new Set(updatedMessages.map(msg => msg.whatsapp_message_id || msg.id));
      const newMessages = incomingMessages.filter(
        msg => !existingIds.has(msg.whatsapp_message_id || msg.id)
      );

      return {
        ...state,
        currentMessages: [...updatedMessages, ...newMessages].sort(
          (a, b) => new Date(a.created_at) - new Date(b.created_at)
        )
      };

    case WhatsAppActionTypes.SET_WHATSAPP_PAGE_INFO:
      return {
        ...state,
        pageInfo: action.payload
      };

    case WhatsAppActionTypes.SET_LOADING_SCREEN:
      return {
        ...state,
        loadingScreen: action.payload
      };

    case WhatsAppActionTypes.GET_QR_BASE64_FAILURE:
    case WhatsAppActionTypes.LIST_INSTANCES_FAILURE:
    case WhatsAppActionTypes.EDIT_INSTANCE_FAILURE:
    case WhatsAppActionTypes.GET_WHATSAPP_CHATS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default whatsappReducer;
